import { create } from "zustand"

import type { SortDirection, UseCaseFilters } from "@/features/use-cases/types/use-case.types"

type UseCasesStore = {
  activeTab: "dashboard" | "factsheet"
  setActiveTab: (tab: "dashboard" | "factsheet") => void

  selectedUseCaseId: string | null
  setSelectedUseCaseId: (id: string | null) => void

  filters: UseCaseFilters
  setFilters: (filters: UseCaseFilters) => void

  sortColumn: string
  sortDirection: SortDirection
  setSort: (column: string, direction: SortDirection) => void

  isAdminView: boolean
  setIsAdminView: (isAdmin: boolean) => void
}

export const useUseCasesStore = create<UseCasesStore>()((set) => ({
  activeTab: "dashboard",
  setActiveTab: (tab) => set({ activeTab: tab }),

  selectedUseCaseId: null,
  setSelectedUseCaseId: (id) => set({ selectedUseCaseId: id }),

  filters: {
    statuses: new Set<string>(),
    tenkCategories: new Set<string>(),
    feasibilities: new Set<string>(),
    sites: new Set<string>(),
    searchText: "",
  },
  setFilters: (filters) => set({ filters }),

  sortColumn: "annualBenefit",
  sortDirection: "desc",
  setSort: (column, direction) => set({ sortColumn: column, sortDirection: direction }),

  isAdminView: false,
  setIsAdminView: (isAdmin) => set({ isAdminView: isAdmin }),
}))
